import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'rpe-nsm2',
  templateUrl: './rpe-nsm2.component.html',
  styleUrl: './rpe-nsm2.component.scss'
})
export class RpeNsm2Component {

}
